import { Tag } from '@s4l/ds'
import { IconArrowLineDown } from '@s4l/icons/IconArrowLineDown'
import { useS4LContext } from '@s4l/react-context'
import cn from 'classnames'
import React from 'react'
import { useDispatch } from 'react-redux'
import { routes } from 'src/constants/routes'
import { enableInsuranceAction } from 'src/effects/Availability/actions'
import Affiliate from 'src/comps/Affiliate'
import InsuranceSelector from './InsuranceSelector'
import OfferConditions from './OfferConditions'
import OfferResponsivePriceAndButtons from './OfferResponsivePriceAndButton'
import styles from './styles.module.css'

interface OfferResponsiveProps {
  board: any
  isLoading?: boolean
  isMultiRoom: boolean
  isSelected: boolean
  nights: number
  onClick: (arg: any) => void
  prime?: boolean
  showAffiliate: boolean
  showOldAffiliateLogo?: boolean
  affiliateId?: string
  showMore?: JSX.Element
  bestPrice?: boolean
}

const OfferResponsive = ({
  board,
  isLoading = false,
  isMultiRoom,
  isSelected,
  nights,
  onClick,
  prime = false,
  showAffiliate,
  showOldAffiliateLogo = false,
  affiliateId,
  showMore,
  bestPrice = false,
}: OfferResponsiveProps) => {
  const pageId = routes.detail.page
  const dispatch = useDispatch()
  const { i18n } = useS4LContext()

  const handleClickBook = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()

    if (!isLoading) {
      onClick({ board, isRemove: isSelected })
    }
  }

  const handleClickInsurance = (isEnable: boolean) => {
    dispatch(
      enableInsuranceAction({
        availabilityId: board.availabilityId,
        insuranceSelected: isEnable,
      })
    )
  }

  return (
    <div
      className={cn(styles.offerContainer, {
        [styles.offerHighlighted]: showAffiliate,
      })}
    >
      <div className={styles.boardContainer}>
        {showAffiliate && (
          <div className={styles.yourSelectionTagContainer}>
            <Tag
              icon={<IconArrowLineDown />}
              color="var(--color-base-white)"
              bgColor="var(--color-neutral-800)"
              size="s"
            >
              {i18n.formatMessage({ id: 'global.your-choice' })}
            </Tag>
          </div>
        )}
        {showOldAffiliateLogo && (
          <div className={styles.oldAffiliateLogoContainer}>
            <Affiliate id={affiliateId} />
          </div>
        )}
        <OfferConditions
          code={board.code}
          cancellation={board.cancellation}
          currency={board.currency}
          name={board.boardName}
          paymentPolicy={board.paymentPolicy}
          payRate={board.payRate}
          isMobile={board.isMobile}
          bestPrice={bestPrice}
        />
        {board.insurance && (
          <InsuranceSelector
            {...board.insurance}
            isSelected={board.insuranceSelected}
            onClick={handleClickInsurance}
            consumer={pageId}
          />
        )}
      </div>
      <OfferResponsivePriceAndButtons
        board={board}
        isLoading={isLoading}
        isMultiRoom={isMultiRoom}
        isSelected={isSelected}
        nights={nights}
        onClick={handleClickBook}
        prime={prime}
        showMore={showMore}
      />
    </div>
  )
}

export default OfferResponsive
